var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.097,
    height: 19.527,
    viewBox: "0 0 17.097 19.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9718",
    "data-name": "Group 9718",
    transform: "translate(-23 -316.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M17.1,1.5c0,.828-3.827,1.5-8.548,1.5S0,2.328,0,1.5,3.827,0,8.548,0,17.1.672,17.1,1.5",
    transform: "translate(23 333)",
    fill: "#e4e3e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "padlock",
    transform: "translate(22 316.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18772",
    "data-name": "Path 18772",
    d: "M14.5,19.955H4.643A1.645,1.645,0,0,1,3,18.311V10.643A1.645,1.645,0,0,1,4.643,9H14.5a1.645,1.645,0,0,1,1.643,1.643v7.668A1.645,1.645,0,0,1,14.5,19.955ZM4.643,10.1a.548.548,0,0,0-.548.548v7.668a.548.548,0,0,0,.548.548H14.5a.548.548,0,0,0,.548-.548V10.643A.548.548,0,0,0,14.5,10.1Z",
    transform: "translate(0 -2.427)",
    fill: "#363954"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18773",
    "data-name": "Path 18773",
    d: "M14.216,7.668a.548.548,0,0,1-.548-.548V4.382a3.286,3.286,0,0,0-6.573,0V7.12a.548.548,0,1,1-1.1,0V4.382a4.382,4.382,0,1,1,8.764,0V7.12A.548.548,0,0,1,14.216,7.668Z",
    transform: "translate(-0.809)",
    fill: "#363954"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18774",
    "data-name": "Path 18774",
    d: "M11.461,15.921a1.461,1.461,0,1,1,1.461-1.461A1.462,1.462,0,0,1,11.461,15.921Zm0-1.826a.365.365,0,1,0,.365.365A.366.366,0,0,0,11.461,14.1Z",
    transform: "translate(-1.888 -3.506)",
    fill: "#363954"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18775",
    "data-name": "Path 18775",
    d: "M11.8,18.854a.548.548,0,0,1-.548-.548V16.3a.548.548,0,1,1,1.1,0v2.008A.548.548,0,0,1,11.8,18.854Z",
    transform: "translate(-2.225 -4.248)",
    fill: "#363954"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.c93ed8d094a67533efeb611a73058683.svg";
export { ForwardRef as ReactComponent };